// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2h1vY","content":"styles_content__27vU6","tableWrap":"styles_tableWrap__28eAz"};